import { jsx as _jsx } from "react/jsx-runtime";
import { Skeleton as AntSkeleton, Table } from 'antd';
import styled from 'styled-components';
const StyledSkeleton = styled(AntSkeleton)`
  margin: 0;
  & .ant-skeleton-title {
    margin: 0;
    padding: 0;
    display: block;
    width: 64px;
    height: 1rem;
  }
`;
const StyledTable = styled(Table)`
  .ant-table-tbody > tr > td {
    border-bottom: 1px solid var(--table-border-color);
  }

  .ant-table-thead > tr > th::before {
    display: none;
  }
`;
export const TableSkeleton = (props)=>{
    const { active = true, columnCount = 5, rowCount = 5, size = 'middle', showHeader = true, className } = props;
    const Skeleton = ()=>/*#__PURE__*/ _jsx(StyledSkeleton, {
            active: active,
            avatar: false,
            paragraph: false
        });
    const rows = Array.from({
        length: rowCount
    }, (_, idx)=>({
            key: `row-idx-${idx}`
        }));
    const columns = Array.from({
        length: columnCount
    }, (_, idx)=>({
            title: /*#__PURE__*/ _jsx(Skeleton, {}),
            render: ()=>/*#__PURE__*/ _jsx(Skeleton, {}),
            key: `col-idx-${idx}`
        }));
    return /*#__PURE__*/ _jsx(StyledTable, {
        className: className,
        size: size,
        dataSource: rows,
        columns: columns,
        showHeader: showHeader,
        pagination: false
    });
};
